let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("5PRFh")), load("32rAF")]).then(() => parcelRequire('16LzX'));